<template>
  <div class="mypage-user-complete-section">
    <p>{{ $t('MypagePage.MypageUserCompletePage.completeMessage') }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * マイページ: 会員情報変更完了 コンテンツセクション
 */
export default defineComponent({
  name: 'MypageUserCompleteSection',
  methods: {},
})
</script>

<style lang="scss" scoped>
.mypage-user-complete-section {
  padding-top: 80px;
  @include fontSetTextMedium(17);

  letter-spacing: 0.04em;
}
</style>
